<template>
	<div class="header">
		<div class="container-fluid">
			<div class="mt-5">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Notification Setting</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<!-- Card  -->
			<div class="card">
				<div class="card-header">
					<!-- Title -->
					<h4 class="card-header-title">Notification Setting</h4>
					<!-- Button -->
					<div class="card-header-title form-group col-2">
						<input type="text" v-model="bodyEmail.search" class="form-control" placeholder="Search" @input="getList()" />
					</div>
					<!--b-button variant="primary" @click="addModalEmail()">
						<span class="fe fe-plus-circle"></span>
						Add
					</-b-button -->
				</div>
				<div class="overflow-auto">
					<vue-good-table
						:line-numbers="true"
						:columns="columnsEmail"
						:rows="list.data"
						:sort-options="{
							enabled: true,
						}"
						:total-rows="list.totalItems"
						:pagination-options="{
							enabled: true,
							mode: 'pages',
							position: 'bottom',
							perPage: 10,
							perPageDropdown: [10, 50, 100],
							dropdownAllowAll: false,
							setCurrentPage: 1,
							nextLabel: 'next',
							prevLabel: 'prev',
							rowsPerPageLabel: 'Rows per page',
							ofLabel: 'of',
							pageLabel: 'page',
							allLabel: 'All',
						}"
						style-class="vgt-table border-0 table"
						@on-sort-change="onSortChange"
						@on-page-change="onPageChangeEmail"
						@on-per-page-change="onPageChangeEmail"
					>
						<!-- Loading -->
						<div slot="emptystate" class="text-center font-size-14">No data available</div>
						<!-- Custom Rows -->
						<template slot="table-row" slot-scope="props">
							<!-- Table Action -->
							<span v-if="props.column.field == 'action'">
								<b-button
									class="no-wrap ml-2"
									variant="warning"
									style="margin-left: 5px"
									size="sm"
									@click="updateEmail(props.row)"
								>
									<span class="fe fe-edit"></span>
								</b-button>
								<b-button
									class="no-wrap ml-2"
									variant="danger"
									style="margin-left: 5px"
									size="sm"
									@click="deleteEmail(props.row.id)"
								>
									<span class="fe fe-trash-2"></span>
								</b-button>
							</span>
							<span v-else-if="props.column.field == 'template'">
								<div v-html="props.row.template"></div>
							</span>
							<span
								v-else-if="
									props.column.field == 'budget_notification' && props.row.notification_type == 'Remaining Contract Budget'
								"
							>
								{{ props.row.budget_notification }}%
							</span>
							<span
								v-else-if="
									props.column.field == 'budget_notification' && props.row.notification_type == 'Reminder Expiration Date'
								"
							>
								{{ props.row.budget_notification }} day(s)
							</span>
						</template>
					</vue-good-table>
				</div>
			</div>
			<!-- Modal -->
			<b-modal id="modal-1" size="xl" hide-footer title="Notification Setting Form" @hide="closeNotificationModal($event)">
				<form @submit.prevent="saveAdd()" v-if="isAdd === true">
					<div class="row g-3">
						<div class="form-group col">
							<label>Notification Type <span class="text-danger">*</span></label>
							<v-select
								v-model="modalEmail.notification_type"
								:options="optionNotifType"
								v-validate="'required'"
								name="Notification Type"
							/>
							<span class="text-sm text-danger" v-show="errors.has('Notification Type')">{{
								errors.first('Notification Type')
							}}</span>
						</div>
						<div class="form-group col">
							<label>Notification Thresshold <span class="text-danger"></span></label>
							<input
								type="number"
								v-model="modalEmail.budget_notification"
								class="form-control"
								placeholder="Notification Thresshold in percentage or days"
								v-validate="'required'"
								name="Notification Thresshold"
							/>
							<span class="text-sm text-danger" v-show="errors.has('Notification Thresshold')">{{
								errors.first('Notification Thresshold ')
							}}</span>
						</div>
					</div>
					<div class="row g-3">
						<div class="form-group col-6">
							<div class="form-group col-12 p-0">
								<label>Notification Description </label>
								<input
									type="text"
									v-model="modalEmail.description"
									class="form-control"
									placeholder="Notification Budget"
									v-validate="'required'"
									name="Notification Budget"
								/>
							</div>
							<div class="row g-3">
								<div class="form-group col">
									<label>Notification Recurring </label>
									<div class="input-group">
										<div class="input-group-append">
											<b-button size="sm" variant="primary" @click="modalEmail.notification_time--">
												<span class="fe fe-minus"></span>
											</b-button>
										</div>
										<input type="number" class="form-control" disabled v-model="modalEmail.notification_time" />
										<div class="input-group-append">
											<b-button size="sm" variant="primary" @click="modalEmail.notification_time++">
												<span class="fe fe-plus"></span>
											</b-button>
										</div>
										<div class="input-group-append">
											<div class="input-group-text"><b>Days</b></div>
										</div>
									</div>
								</div>
								<div class="form-group col">
									<label>Recurring At</label><br />
									<v-timepicker format="HH:mm" v-model="modalEmail.recurrence_at"></v-timepicker>
								</div>
							</div>
						</div>
						<div class="form-group col-6">
							<label>Default Recipient</label>
							<v-select
								name="Default Recipient"
								v-validate="'required'"
								v-model="modalEmail.default_recipient"
								:options="listUser"
								label="email"
								:reduce="(e) => e.email"
								:placeholder="'Please select recipient'"
								multiple
							>
								<template #option="{ fullname }">
									<div>{{ fullname }}</div>
								</template>
							</v-select>
							<span class="text-sm text-danger" v-show="errors.has('Default Recipient')">{{
								errors.first('Default Recipient')
							}}</span>
						</div>
					</div>
					<div class="form-group">
						<label>Template </label>
					</div>
					<div class="from-group">
						<div class="row">
							<div class="col-12 col-lg-5 col-sm">
								<div class="card-body" style="background-color: #a1a1a180">
									<div class="card-body" style="background-color: white; border-radius: 10px">
										<div class="row align-items-center gx-0" style="color: #a1a1a1">
											<div class="col">
												<h4>Email Variable:</h4>
												<div class="col">
													<span class="ml-2">- [notification_type] : Notification Type</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [notification_time] : Notification Schedule</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [budget_notification] : Notification Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [created_date] : Create Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [created_by] : Admin Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [closed_date] : Close Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [closed_by] : Close Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [terminated_date] : Terminate Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [terminated_by] : Terminate Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [amandement_date] : Amandement Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [amandement_by] : Amandement Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [no] : Contract Number</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [name] : Contract Name</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [type_contract] : Type of Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_owner] : Contract Owner</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_co_owner] : Contract Co-Owner</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_duration] : Contract Duration</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [status] : Contract Status</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [link_contract] : Link to Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [year] : Budget year</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [budget] : Contract Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [vendor] : Vendor</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [remaining_budget] : Remaining Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [start_date] : Contract Start Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [end_date] : Contract End Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [notes] : Notes</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-6 col-xl">
								<div class="form-group">
									<label>Email Subject <span class="text-danger">*</span></label>
									<input
										type="text"
										v-model="modalEmail.subject"
										class="form-control"
										placeholder="Email Subject"
										v-validate="'required'"
										name="Email Subject"
									/>
									<span class="text-sm text-danger" v-show="errors.has('Email Subject')">{{
										errors.first('Email Subject')
									}}</span>
								</div>
								<div class="form-group">
									<label>Email Body <span class="text-danger">*</span></label>
									<vue-editor v-model="modalEmail.template" v-validate="'required'" name="Email Body" />
									<span class="text-sm text-danger" v-show="errors.has('Email Body')">{{ errors.first('Email Body') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<button
							style="margin-left: auto; float: right"
							class="mt-4 btn btn-primary"
							type="submit"
							v-if="isLoading == false"
						>
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
						<button
							type="button"
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-outline-primary mr-3"
							@click="$bvModal.hide('modal-1')"
						>
							Cancel
						</button>
					</div>
				</form>

				<form @submit.prevent="saveUpdate()" v-else>
					<div class="row g-3">
						<div class="form-group col">
							<label>Notification Type <span class="text-danger">*</span></label>
							<v-select
								v-model="modalUpdateEmail.notification_type"
								:options="optionNotifType"
								v-validate="'required'"
								name="Notification Type"
							/>
							<span class="text-sm text-danger" v-show="errors.has('Notification Type')">{{
								errors.first('Notification Type')
							}}</span>
						</div>
						<div class="form-group col">
							<label>Notification Thresshold(%) <span class="text-danger">*</span></label>
							<input
								type="number"
								v-model="modalUpdateEmail.budget_notification"
								class="form-control"
								placeholder="Notification Budget"
								v-validate="'required'"
								name="Notification Budget"
							/>
							<span class="text-sm text-danger" v-show="errors.has('Notification Budget ')">{{
								errors.first('Notification Budget ')
							}}</span>
						</div>
					</div>
					<div class="row g-3">
						<div class="form-group col-6">
							<div class="form-group col-12 p-0">
								<label>Notification Description </label>
								<input
									type="text"
									v-model="modalUpdateEmail.description"
									class="form-control"
									placeholder="Notification Budget"
									v-validate="'required'"
									name="Notification Budget"
								/>
							</div>
							<div class="row g-3">
								<div class="form-group col">
									<label>Notification Recurring </label>
									<div class="input-group">
										<div class="input-group-append">
											<b-button size="sm" variant="primary" @click="modalUpdateEmail.notification_time--">
												<span class="fe fe-minus"></span>
											</b-button>
										</div>
										<input type="number" class="form-control" disabled v-model="modalUpdateEmail.notification_time" />
										<div class="input-group-append">
											<b-button size="sm" variant="primary" @click="modalUpdateEmail.notification_time++">
												<span class="fe fe-plus"></span>
											</b-button>
										</div>
										<div class="input-group-append">
											<div class="input-group-text"><b>Days</b></div>
										</div>
									</div>
								</div>
								<div class="form-group col">
									<label>Recurring At</label><br />
									<v-timepicker format="HH:mm" v-model="modalUpdateEmail.recurrence_at"></v-timepicker>
								</div>
							</div>
						</div>
						<div class="form-group col-6">
							<label>Default Recipient</label>
							<v-select
								name="Default Recipient"
								v-validate="'required'"
								v-model="modalUpdateEmail.default_recipient"
								:options="listUser"
								label="email"
								:reduce="(e) => e.email"
								:placeholder="'Please select recipient'"
								multiple
							>
								<template #option="{ fullname, department }">
									<div>{{ `${fullname} - ${department ? department : ''}` }}</div>
								</template>
							</v-select>
							<span class="text-sm text-danger" v-show="errors.has('Default Recipient')">{{
								errors.first('Default Recipient')
							}}</span>
						</div>
					</div>
					<div class="form-group">
						<label>Template </label>
					</div>
					<div class="from-group">
						<div class="row">
							<div class="col-12 col-lg-5 col-sm">
								<div class="card-body" style="background-color: #a1a1a180">
									<div class="card-body" style="background-color: white; border-radius: 10px">
										<div class="row align-items-center gx-0" style="color: #a1a1a1">
											<div class="col">
												<h4>Email Variable:</h4>
												<div class="col">
													<span class="ml-2">- [notification_type] : Notification Type</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [notification_time] : Notification Schedule</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [budget_notification] : Notification Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [created_date] : Create Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [created_by] : Admin Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [closed_date] : Close Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [closed_by] : Close Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [terminated_date] : Terminate Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [terminated_by] : Terminate Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [amandement_date] : Amandement Contract Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [amandement_by] : Amandement Initiator</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [no] : Contract Number</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [name] : Contract Name</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [type_contract] : Type of Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_owner] : Contract Owner</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_co_owner] : Contract Co-Owner</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [contract_duration] : Contract Duration</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [status] : Contract Status</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [link_contract] : Link to Contract</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [year] : Budget year</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [budget] : Contract Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [vendor] : Vendor</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [remaining_budget] : Remaining Budget</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [start_date] : Contract Start Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [end_date] : Contract End Date</span>
												</div>
												<div class="col mt-2">
													<span class="ml-2">- [notes] : Notes</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 col-lg-6 col-xl">
								<div class="form-group">
									<label>Email Subject <span class="text-danger">*</span></label>
									<input
										type="text"
										v-model="modalUpdateEmail.subject"
										class="form-control"
										placeholder="Email Subject"
										v-validate="'required'"
										name="Email Subject"
									/>
									<span class="text-sm text-danger" v-show="errors.has('Email Subject')">{{
										errors.first('Email Subject')
									}}</span>
								</div>
								<div class="form-group">
									<label>Email Body <span class="text-danger">*</span></label>
									<vue-editor v-model="modalUpdateEmail.template" v-validate="'required'" name="Email Body" />
									<span class="text-sm text-danger" v-show="errors.has('Email Body')">{{ errors.first('Email Body') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<button
							style="margin-left: auto; float: right"
							class="mt-4 btn btn-primary"
							type="submit"
							v-if="isLoading == false"
						>
							Save
						</button>
						<button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
						<button
							style="margin-right: auto; float: right"
							class="mt-4 btn btn-outline-primary mr-3"
							type="button"
							@click="$bvModal.hide('modal-1')"
						>
							Cancel
						</button>
					</div>
				</form>
			</b-modal>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'listContract',
		computed: {
			list() {
				return this.$store.getters['notification/list'];
			},
			// listTypeNotification() {
			//   return this.$store.getters["notification_type/list"];
			// },
			listUser() {
				const users = this.$store.getters['listContract/listUser'] || [];
				const uniqueUser = new Map();
				for (const user of users) {
					uniqueUser.set(user.email, {
						id: user.id,
						fullname: user.fullname,
						email: user.email,
						department: user.department || user.divisi || user.departments?.[0]?.name,
					});
				}
				return Array.from(uniqueUser.values());
			},
		},
		data() {
			return {
				bodyEmail: {
					page: 1,
					pageSize: 10,
					order: '',
					search: '',
				},
				bodyWhatsApp: {
					pageSize: 1,
					limit: 10,
					order: '',
				},
				direct: 'Email',
				breadcrumb: 'Email',
				isAdd: true,
				isAddEmail: true,
				isLoading: false,
				id: '',
				modalEmail: {
					notification_type: '',
					notification_time: 1,
					budget_notification: '',
					subject: '',
					template: '',
					description: '',
					recurrence_at: '',
					default_recipient: [],
				},
				modalUpdateEmail: {
					notification_type: '',
					notification_time: 1,
					budget_notification: '',
					subject: '',
					template: '',
					description: '',
					recurrence_at: '',
					default_recipient: [],
				},
				optionNotifType: [
					'Issuance of New Contract',
					'Completed Contract',
					'Termination of Contract',
					'Contract Expiration Date',
					'Remaining Contract Budget',
					'Contract Amandement',
					'Reminder Contract Budget Year',
				],
				columnsEmail: [
					{
						label: 'Notification Type',
						field: 'notification_type',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Recurring',
						field: (field) =>
							`${field.notification_time} ${field.notification_time > 1 ? 'days' : 'day'} at ${
								field.recurrence_at ? field.recurrence_at.slice(0, 5) : '00:00'
							}`,
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Notification Thresshold',
						field: 'budget_notification',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Email Subject',
						field: 'subject',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
				],
			};
		},
		mounted() {
			this.getList();
			// this.getTypeNotification();
			this.getListUser();
		},

		watch: {
			'modalEmail.notification_time'(val) {
				if (val < 1) this.modalEmail.notification_time = 1;
			},
			'modalUpdateEmail.notification_time'(val) {
				if (val < 1) this.modalUpdateEmail.notification_time = 1;
			},
		},
		methods: {
			// getTypeNotification() {
			//   this.$store.dispatch("notification_type/GET_LIST", this.bodyEmail);
			// },
			saveAdd() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;
					this.isLoading = true;
					try {
						this.modalEmail.budget_notification = Number(this.modalEmail.budget_notification);
						this.$store
							.dispatch('notification/CREATE_DATA', this.modalEmail)
							.then((resp) => {
								this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
									this.isLoading = false;
									this.modalEmail = {
										notification_type: '',
										notification_time: 1,
										budget_notification: '',
										subject: '',
										template: '',
										description: '',
										default_recipient: [],
									};
									this.getList();
									this.$bvModal.hide('modal-1');
								});
							})
							.catch((err) => {
								this.isLoading = false;
								this.$swal('Error', err.response.data.error, 'error');
							});
					} catch (error) {
						this.$swal('Error', 'Error while add data', 'error');
					}
				});
			},
			saveUpdate() {
				this.modalUpdateEmail.budget_notification = Number(this.modalUpdateEmail.budget_notification);
				let body = {
					id: this.id,
					data: { ...this.modalUpdateEmail },
				};
				this.isLoading = true;
				this.$store
					.dispatch('notification/UPDATE_DATA', body)
					.then((resp) => {
						this.$swal('Saved', 'Your input has been saved', 'success').then((resp) => {
							this.isLoading = false;
							this.modalUpdateEmail = {
								notification_type: '',
								notification_time: 1,
								budget_notification: '',
								subject: '',
								template: '',
								description: '',
								recurrence_at: '',
								default_recipient: [],
							};
							this.getList();
							this.$bvModal.hide('modal-1');
						});
					})
					.catch((err) => {
						this.isLoading = false;
						this.$swal('Error', err.response.data.error, 'error');
					});
			},
			addModalEmail(props) {
				this.modalEmail = {
					notification_type: '',
					notification_time: 1,
					budget_notification: '',
					subject: '',
					template: '',
					description: '',
					recurrence_at: '',
					default_recipient: [],
				};
				this.$bvModal.show('modal-1');
				this.isAdd = true;
			},
			updateEmail(props) {
				this.$bvModal.show('modal-1');
				this.isAdd = false;
				this.modalUpdateEmail.notification_type = props.notification_type;
				this.modalUpdateEmail.notification_time = props.notification_time;
				this.modalUpdateEmail.budget_notification = props.budget_notification;
				this.modalUpdateEmail.subject = props.subject;
				this.modalUpdateEmail.template = props.template;
				this.modalUpdateEmail.description = props.description;
				this.modalUpdateEmail.recurrence_at = props.recurrence_at || '';
				this.modalUpdateEmail.default_recipient = props.default_recipient ? JSON.parse(props.default_recipient) : [];
				this.id = props.id;
			},

			deleteEmail(id) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('notification/DELETE_DATA', id)
							.then((resp) => {
								this.getList();
								this.$swal('Deleted!', 'Your data has been deleted', 'success');
							})
							.catch((resp) => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},
			detailEmail(props) {
				console.log(props);
			},

			checkVal() {
				if (this.modalEmail.notification_type.length > 0) {
					return false;
				} else {
					return true;
				}
			},
			getList() {
				this.$store.dispatch('notification/GET_LIST', this.bodyEmail);
			},
			getListUser() {
				if (this.listUser.length > 0) return;
				this.$store.dispatch('listContract/GET_USER', {
					department_id: '',
				});
			},
			// filter
			filterPage() {},

			sorting() {
				this.getList();
			},

			onSortChange(event) {
				this.bodyEmail.order = event[0].type == 'none' ? '' : event[0].type;
				this.getList();
			},

			// Pagination
			onPageChangeEmail(payload) {
				this.bodyEmail.pageSize = payload.currentPerPage;
				this.bodyEmail.page = payload.currentPage;
				this.getList();
			},
			closeNotificationModal(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.confirmAndCloseModal();
				}
			},
			confirmAndCloseModal() {
				this.$swal({
					title: 'Confirm Close?',
					text: 'Are you sure you want to close this page?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$bvModal.hide('modal-1');
					} else {
						console.log('Modal close cancelled from button.');
					}
				});
			},
		},
	};
</script>

<style>
	.vgt-wrap__footer.vgt-clearfix {
		width: 100% !important;
		min-width: var(--vgt-table-min-width, 100%);
	}

	.vgt-inner-wrap {
		min-width: fit-content;
	}
</style>
